import { render, staticRenderFns } from "./RiskProtectionSidebar.vue?vue&type=template&id=6fb80350"
import script from "./RiskProtectionSidebar.vue?vue&type=script&lang=js"
export * from "./RiskProtectionSidebar.vue?vue&type=script&lang=js"
import style0 from "./RiskProtectionSidebar.vue?vue&type=style&index=0&id=6fb80350&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports